import { render, staticRenderFns } from "./fundraising.vue?vue&type=template&id=1ad4063d&"
import script from "./fundraising.vue?vue&type=script&lang=js&"
export * from "./fundraising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports